<p-panel>
	<p-header><h3>{{ 'psv.Person' | hisUi }}</h3></p-header>
    <div class="infoMessage" [innerHTML]="'fs.res.publication.creators.wizard.person.helptext' | hisUi"></div>
	<form [formGroup]="creatorNameForm" novalidate>
		<his-plam>
			<input #content class="inputWidth100" formControlName="creatorname" 
			hisDdKey="fs.res.publication.PublicationHumanCreator.creatorName" (change)="onChange()" (keydown.enter) ="onKeyDownEnter()" >
		</his-plam>
		<his-plam>
			<input #content formControlName="firstname" class="inputWidth100"
			hisDdKey="fs.res.publication.PublicationHumanCreator.firstName"   (change)="onChange()" (keydown.enter) ="onKeyDownEnter()">
		</his-plam>
		<his-plam>
			<input #content formControlName="nameprefix" class="inputWidth100"
			hisDdKey="fs.res.publication.PublicationHumanCreator.nameprefix" (change)="onChange()" (keydown.enter) ="onKeyDownEnter()" >
		</his-plam>
		<his-plam>
			<input #content formControlName="namesuffix" class="inputWidth100"
			hisDdKey="fs.res.publication.PublicationHumanCreator.namesuffix" (change)="onChange()" (keydown.enter) ="onKeyDownEnter()" >
		</his-plam>
	</form>
</p-panel>
